module.exports = __webpack_public_path__ + "img/temperature-empty.5ce9d4a0.svg";